import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rounded-Xh-8M",
  "use": "rounded-Xh-8M-usage",
  "viewBox": "0 0 12 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 10\" id=\"rounded-Xh-8M\"><path fill-rule=\"evenodd\" d=\"M12.003 1.797a.751.751 0 0 0-.216-.527L10.733.217a.751.751 0 0 0-1.053 0L4.6 5.305 2.323 3.02a.751.751 0 0 0-1.053 0L.217 4.073a.751.751 0 0 0 0 1.054l3.856 3.856a.751.751 0 0 0 1.054 0l6.66-6.66a.751.751 0 0 0 .216-.526z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol